import styled from "@emotion/styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"
import { isIpad } from "../../../util/deviceType"
export interface StylesProps {
  roomStyles?: RoomBranding
  borderColor?: string
  error?: string
  isWindows?: boolean
}

export const Input = styled.input<StylesProps>`
  display: flex;
  position: relative;
  width: 100%;
  box-shadow: none;
  background-color: white;
  padding-inline-start: calc(1rem - 3px);
  padding-inline-end: calc(1rem - 3px);
  color: black;
  border: 2px;
  font-weight: 400;
  line-height: 1.5;
  border-style: solid;
  border-radius: 0.375rem;
  height: 2.5rem;
  border-color: ${({ roomStyles, borderColor }) => borderColor ?? "#E2E8F0"};

  &:focus {
    border-color: ${({ roomStyles, error }) =>
      isIpad() ? "#718096 !!!important" : "#718096"};
    outline: none;
  }

  &:focus-visible {
    border-color: ${({ roomStyles, error }) => "#718096 !!!important"};
    outline: unset;
  }

  ::placeholder {
    color: #3f4c5b;
    /* padding-left: ${({ isWindows }) => isWindows && "2px"}; */
  }
`
